// // import React, { Component } from 'react'
// // import { Link } from "react-router-dom";
// // import LogOut from "../components/LogOut";
// // import editplatform from "../assets/eye.png";
// // import editnumber from "../assets/pen-number.png";
// // import duplicate from "../assets/dublicat.png";

// // export class Whats extends Component {
// //   render() {
// //     return (
// //      <div className="seo-page">
// //         {/* Navbar */}
// //         <nav className="seo-navbar">
// //           {/* <button className="nav-btn left-btn">اضافة عمميل جديد</button> */}
// //           <h1 className="nav-title">حملات الواتس اب</h1>
// //           <LogOut />

// //           <button className="add1">
// //             <Link to="/admin">العودة للرئيسية</Link>
// //           </button>

// //         </nav>

// //         {/* Page Content */}
// //         <div className="admin_area">
// //           <table className="users-table">
// //             <thead>
// //               <tr>
// //                 <th>اسم البراند</th>
// //                 <th>تاريخ الحملة</th>
// //                 <th> اسم الكود</th>
// //                 <th>المبيعات</th>
// //                 <th>الإجراءات</th>
// //               </tr>
// //             </thead>
// //             <tbody>
// //               <tr>
// //                 <td>Brand A</td>

// //                 <td>120</td>
// //                 <td>5000</td>
// //                 <td>300 / 8000</td>

// //                 <td className="editdelet">
// //                   <button className="delete-btn">
// //                     <img src={editnumber} alt="edit" />
// //                   </button>
// //                   <button className="edit-btn">
// //                     <img src={editplatform} alt="edit" />
// //                   </button>
// //                          <button className="edit-btn">
// //                     <img src={duplicate} alt="edit" />
// //                   </button>
// //                 </td>{" "}
// //               </tr>

// //             </tbody>
// //           </table>
// //         </div>
// //       </div>
// //     )
// //   }
// // }

// // export default Whats

// // import React, { Component } from "react";
// // import { Link } from "react-router-dom";
// // import LogOut from "../components/LogOut";
// // import editplatform from "../assets/openeye.png"; // عين مقفولة (هتضيف انت المفتوحة)
// // import editnumber from "../assets/pen-number.png";
// // import duplicate from "../assets/dublicat.png";
// // import trashicon from "../assets/trash.png"; // أيقونة الحذف

// // export class Whats extends Component {
// //   state = {
// //     whatsappData: [],
// //     showPopup: false,
// //     currentCampaign: null,
// //     formData: {},
// //   };

// //   componentDidMount() {
// //     this.fetchWhatsappData();
// //   }

// //   // جلب بيانات الحملات
// //   fetchWhatsappData = async () => {
// //     try {
// //       const token = localStorage.getItem("token");
// //       const res = await fetch("http://backend.goldensection.agency/public/api/getuser", {
// //         headers: {
// //           Authorization: `Bearer ${token}`,
// //           "Content-Type": "application/json",
// //         },
// //       });
// //       const data = await res.json();

// //       if (data.users && data.users.length > 0) {
// //         // ناخد كل حملات الواتساب ونربطها بالبراند
// //         const campaigns = data.users.flatMap((u) =>
// //           u.whatsapp.map((w) => ({
// //             ...w,
// //             brand_name: u.brand,
// //           }))
// //         );
// //         this.setState({ whatsappData: campaigns });
// //       }
// //     } catch (err) {
// //       console.error("Error fetching WhatsApp campaigns:", err);
// //     }
// //   };

// //   // فتح البوب اب للتعديل
// //   handleEditClick = (campaign) => {
// //     this.setState({
// //       showPopup: true,
// //       currentCampaign: campaign,
// //       formData: { ...campaign },
// //     });
// //   };

// //   // حذف حملة
// //   handleDelete = async (id) => {
// //     if (window.confirm("هل انت متأكد من الحذف؟")) {
// //       try {
// //         const token = localStorage.getItem("token");
// //         await fetch(
// //           `http://backend.goldensection.agency/public/api/deletewhatsapp/${id}`,
// //           {
// //             method: "DELETE",
// //             headers: {
// //               Authorization: `Bearer ${token}`,
// //               "Content-Type": "application/json",
// //             },
// //           }
// //         );
// //         this.fetchWhatsappData();
// //       } catch (err) {
// //         console.error("Error deleting WhatsApp campaign:", err);
// //       }
// //     }
// //   };

// //   // تعديل الحملة
// //   handleChange = (e) => {
// //     this.setState({
// //       formData: {
// //         ...this.state.formData,
// //         [e.target.name]: e.target.value,
// //       },
// //     });
// //   };

// //   handleSave = async () => {
// //     try {
// //       const token = localStorage.getItem("token");
// //       await fetch(
// //         `http://backend.goldensection.agency/public/api/updatewhatsapp/${this.state.currentCampaign.id}`,
// //         {
// //           method: "POST",
// //           headers: {
// //             Authorization: `Bearer ${token}`,
// //             "Content-Type": "application/json",
// //           },
// //           body: JSON.stringify(this.state.formData),
// //         }
// //       );
// //       this.setState({ showPopup: false, currentCampaign: null });
// //       this.fetchWhatsappData();
// //     } catch (err) {
// //       console.error("Error updating WhatsApp campaign:", err);
// //     }
// //   };

// //   // إضافة نسخة جديدة (Duplicate)
// //   handleDuplicate = async (campaign) => {
// //     try {
// //       const token = localStorage.getItem("token");
// //       await fetch("http://backend.goldensection.agency/public/api/addwhatsapp", {
// //         method: "POST",
// //         headers: {
// //           Authorization: `Bearer ${token}`,
// //           "Content-Type": "application/json",
// //         },
// //         body: JSON.stringify({
// //           user_id: campaign.user_id,
// //           code_name: campaign.code_name + " Copy",
// //           sales: campaign.sales,
// //           status: campaign.status,
// //         }),
// //       });
// //       this.fetchWhatsappData();
// //     } catch (err) {
// //       console.error("Error duplicating WhatsApp campaign:", err);
// //     }
// //   };

// //   // تغيير الحالة On/Off
// //   toggleStatus = async (campaign) => {
// //     try {
// //       const token = localStorage.getItem("token");
// //       const newStatus = campaign.status === "on" ? "off" : "on";

// //       await fetch(
// //         `http://backend.goldensection.agency/public/api/updatewhatsapp/${campaign.id}`,
// //         {
// //           method: "POST",
// //           headers: {
// //             Authorization: `Bearer ${token}`,
// //             "Content-Type": "application/json",
// //           },
// //           body: JSON.stringify({ ...campaign, status: newStatus }),
// //         }
// //       );

// //       this.fetchWhatsappData();
// //     } catch (err) {
// //       console.error("Error toggling WhatsApp campaign status:", err);
// //     }
// //   };

// //   render() {
// //     const { whatsappData, showPopup, formData } = this.state;

// //     // دمج الحملات حسب البراند
// //     const grouped = whatsappData.reduce((acc, c) => {
// //       if (!acc[c.brand_name]) acc[c.brand_name] = [];
// //       acc[c.brand_name].push(c);
// //       return acc;
// //     }, {});

// //     return (
// //       <div className="seo-page">
// //         {/* Navbar */}
// //         <nav className="seo-navbar">
// //           <h1 className="nav-title">حملات الواتس اب</h1>
// //           <LogOut />
// //           <button className="add1">
// //             <Link to="/admin">العودة للرئيسية</Link>
// //           </button>
// //         </nav>

// //         {/* Page Content */}
// //         <div className="admin_area">
// //           <table className="users-table">
// //             <thead>
// //               <tr>
// //                 <th>اسم البراند</th>
// //                 <th>تاريخ الحملة</th>
// //                 <th>اسم الكود</th>
// //                 <th>المبيعات</th>
// //                 <th>الإجراءات</th>
// //               </tr>
// //             </thead>
// //             <tbody>
// //               {Object.keys(grouped).map((brand) =>
// //                 grouped[brand].map((c, i) => (
// //                   <tr key={c.id}>
// //                     {i === 0 && (
// //                       <td rowSpan={grouped[brand].length}>{brand}</td>
// //                     )}
// //                     <td>{c.created_at?.split("T")[0]}</td>
// //                     <td>{c.code_name}</td>
// //                     <td>{c.sales}</td>
// //                     <td className="editdelet">
// //                       <button
// //                         className="delete-btn"
// //                         onClick={() => this.handleEditClick(c)}
// //                       >
// //                         <img src={editnumber} alt="edit" />
// //                       </button>
// //                       <button
// //                         className="edit-btn"
// //                         onClick={() => this.toggleStatus(c)}
// //                       >
// //                         <img
// //                           src={editplatform}
// //                           alt="toggle"
// //                           style={{ opacity: c.status === "on" ? 1 : 0.4 }}
// //                         />
// //                       </button>
// //                       <button
// //                         className="edit-btn"
// //                         onClick={() => this.handleDuplicate(c)}
// //                       >
// //                         <img src={duplicate} alt="duplicate" />
// //                       </button>
// //                       <button
// //                         className="delete-btn"
// //                         onClick={() => this.handleDelete(c.id)}
// //                       >
// //                         <img src={trashicon} alt="delete" />
// //                       </button>
// //                     </td>
// //                   </tr>
// //                 ))
// //               )}
// //             </tbody>
// //           </table>
// //         </div>

// //         {/* Popup */}
// //         {showPopup && (
// //           <div className="popup-overlay">
// //             <div className="popup">
// //               <button
// //                 className="cancel-btn"
// //                 onClick={() => this.setState({ showPopup: false })}
// //               >
// //                 ×
// //               </button>
// //               <h3>تعديل حملة واتساب</h3>
// //               <input
// //                 type="text"
// //                 name="code_name"
// //                 value={formData.code_name || ""}
// //                 onChange={this.handleChange}
// //                 placeholder="اسم الكود"
// //               />
// //               <input
// //                 type="number"
// //                 name="sales"
// //                 value={formData.sales || ""}
// //                 onChange={this.handleChange}
// //                 placeholder="المبيعات"
// //               />
// //               <div className="popup-actions">
// //                 <button className="save-btn" onClick={this.handleSave}>
// //                   حفظ
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         )}
// //       </div>
// //     );
// //   }
// // }

// // export default Whats;

// // import React, { Component } from "react";
// // import { Link } from "react-router-dom";
// // import LogOut from "../components/LogOut";
// // import closedEye from "../assets/eye.png";
// // import openEye from "../assets/openeye.png";
// // import editnumber from "../assets/pen-number.png";
// // import duplicate from "../assets/dublicat.png";
// // import trash from "../assets/trash.png";

// // export class Whats extends Component {
// //   state = {
// //     campaigns: [],
// //     loading: true,
// //     error: null,
// //     showPopup: false,
// //     currentCampaign: null,
// //     formData: {
// //       code_name: "",
// //       sales: "",
// //     },
// //   };

// //   componentDidMount() {
// //     this.fetchCampaigns();
// //   }

// //   getAuthHeaders() {
// //     return {
// //       "Content-Type": "application/json",
// //       Authorization: `Bearer ${localStorage.getItem("token")}`,
// //     };
// //   }

// //   // جلب الحملات + دمج البراندات المكررة
// //   async fetchCampaigns() {
// //     try {
// //       const res = await fetch(
// //         "http://backend.goldensection.agency/public/api/getuser",
// //         {
// //           headers: this.getAuthHeaders(),
// //         }
// //       );
// //       const data = await res.json();

// //       const allCampaigns = data.users.flatMap((user) =>
// //         (user.whatsapp || []).map((c) => ({
// //           ...c,
// //           brand: user.brand,
// //           user_id: user.id,
// //         }))
// //       );

// //       // دمج حسب البراند
// //       const merged = {};
// //       allCampaigns.forEach((c) => {
// //         if (!merged[c.brand]) {
// //           merged[c.brand] = {
// //             brand: c.brand,
// //             campaigns: [c],
// //           };
// //         } else {
// //           merged[c.brand].campaigns.push(c);
// //         }
// //       });

// //       this.setState({
// //         campaigns: Object.values(merged),
// //         loading: false,
// //       });
// //     } catch (err) {
// //       this.setState({ error: "فشل تحميل الحملات", loading: false });
// //     }
// //   }

// //   handleEdit = (campaign) => {
// //     this.setState({
// //       showPopup: true,
// //       currentCampaign: campaign,
// //       formData: {
// //         code_name: campaign.code_name,
// //         sales: campaign.sales,
// //       },
// //     });
// //   };

// //   handleSave = async () => {
// //     const { currentCampaign, formData } = this.state;
// //     try {
// //       await fetch(
// //         `http://backend.goldensection.agency/public/api/updatewhatsapp/${currentCampaign.id}`,
// //         {
// //           method: "POST",
// //           headers: this.getAuthHeaders(),
// //           body: JSON.stringify(formData),
// //         }
// //       );
// //       this.setState({ showPopup: false });
// //       this.fetchCampaigns();
// //     } catch (err) {
// //       console.error(err);
// //     }
// //   };

// //   handleCancel = () => {
// //     this.setState({ showPopup: false, currentCampaign: null });
// //   };

// //   handleDelete = async (id) => {
// //     if (!window.confirm("هل تريد حذف العنصر بالفعل؟")) return;
// //     try {
// //       await fetch(
// //         `http://backend.goldensection.agency/public/api/deletewhatsapp/${id}`,
// //         {
// //           method: "DELETE",
// //           headers: this.getAuthHeaders(),
// //         }
// //       );
// //       this.fetchCampaigns();
// //     } catch (err) {
// //       console.error(err);
// //     }
// //   };

// //   handleToggleStatus = async (campaign) => {
// //     try {
// //       const newStatus = campaign.status === "on" ? "off" : "on";
// //       await fetch(
// //         `http://backend.goldensection.agency/public/api/updatewhatsapp/${campaign.id}`,
// //         {
// //           method: "POST",
// //           headers: this.getAuthHeaders(),
// //           body: JSON.stringify({ ...campaign, status: newStatus }),
// //         }
// //       );
// //       this.fetchCampaigns();
// //     } catch (err) {
// //       console.error(err);
// //     }
// //   };

// //   // دبل كات مع تاريخ النهاردة + إعادة دمج الحملات
// //   handleDuplicate = async (campaign) => {
// //     try {
// //       await fetch(
// //         "http://backend.goldensection.agency/public/api/addwhatsapp",
// //         {
// //           method: "POST",
// //           headers: this.getAuthHeaders(),
// //           body: JSON.stringify({
// //             user_id: campaign.user_id,
// //             code_name: campaign.code_name + " Copy",
// //             sales: campaign.sales,
// //             status: campaign.status,
// //             created_at: new Date().toISOString(),
// //           }),
// //         }
// //       );
// //       // بعد الدبل كات، نرجع كل الحملات لدمج البراندات
// //       this.fetchCampaigns();
// //     } catch (err) {
// //       console.error(err);
// //     }
// //   };

// //   render() {
// //     const { campaigns, loading, error, showPopup, formData } = this.state;

// //     return (
// //       <div className="seo-page">
// //         <nav className="seo-navbar">
// //           <h1 className="nav-title">حملات الواتس اب</h1>
// //           <LogOut />
// //           <button className="add1">
// //             <Link to="/admin">العودة للرئيسية</Link>
// //           </button>
// //         </nav>

// //         <div className="admin_area">
// //           {loading && <p>جار التحميل...</p>}
// //           {error && <p>{error}</p>}
// //           <table className="users-table">
// //             <thead>
// //               <tr>
// //                 <th>اسم البراند</th>
// //                 <th>تاريخ الحملة</th>
// //                 <th>اسم الكود</th>
// //                 <th>المبيعات</th>
// //                 <th>الإجراءات</th>
// //               </tr>
// //             </thead>
// //             <tbody>
// //               {campaigns.map((brandGroup) =>
// //                 brandGroup.campaigns.map((c, index) => (
// //                   <tr key={c.id}>
// //                     <td>{index === 0 ? brandGroup.brand : ""}</td>
// //                     <td>{new Date(c.created_at).toLocaleDateString()}</td>
// //                     <td>{c.code_name}</td>
// //                     <td>{c.sales}</td>
// //                     <td className="editdelet">
// //                       <button
// //                         className="delete-btn"
// //                         onClick={() => this.handleEdit(c)}
// //                       >
// //                         <img src={editnumber} alt="edit" />
// //                       </button>
// //                       <button
// //                         className="edit-btn"
// //                         onClick={() => this.handleToggleStatus(c)}
// //                       >
// //                         <img
// //                           src={c.status === "on" ? openEye : closedEye}
// //                           alt="status"
// //                         />
// //                       </button>
// //                       <button
// //                         className="edit-btn"
// //                         onClick={() => this.handleDuplicate(c)}
// //                       >
// //                         <img src={duplicate} alt="duplicate" />
// //                       </button>
// //                       <button
// //                         className="edit-btn"
// //                         onClick={() => this.handleDelete(c.id)}
// //                       >
// //                         <img src={trash} alt="trash" />
// //                       </button>
// //                     </td>
// //                   </tr>
// //                 ))
// //               )}
// //             </tbody>
// //           </table>
// //         </div>

// //         {showPopup && (
// //           <div className="popup-overlay">
// //             <div className="popup">
// //               <button className="cancel-btn" onClick={this.handleCancel}>
// //                 ✕
// //               </button>
// //               <label>اسم الكود:</label>
// //               <input
// //                 type="text"
// //                 value={formData.code_name}
// //                 onChange={(e) =>
// //                   this.setState({
// //                     formData: { ...formData, code_name: e.target.value },
// //                   })
// //                 }
// //               />
// //               <label>المبيعات:</label>
// //               <input
// //                 type="number"
// //                 value={formData.sales}
// //                 onChange={(e) =>
// //                   this.setState({
// //                     formData: { ...formData, sales: e.target.value },
// //                   })
// //                 }
// //               />
// //               <div className="popup-actions">
// //                 <button className="save-btn" onClick={this.handleSave}>
// //                   حفظ
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         )}
// //       </div>
// //     );
// //   }
// // }

// // export default Whats;

// import React, { Component } from "react";
// import { Link } from "react-router-dom";
// import LogOut from "../components/LogOut";
// import closedEye from "../assets/eye.png";
// import openEye from "../assets/openeye.png";
// import editnumber from "../assets/pen-number.png";
// import duplicate from "../assets/dublicat.png";
// import trash from "../assets/trash.png";

// const isGust = localStorage.getItem("role") === "gust";

// export class Whats extends Component {
//   state = {
//     campaigns: [],
//     loading: true,
//     error: null,
//     showPopup: false,
//     currentCampaign: null,
//     formData: {
//       code_name: "",
//       sales: "",
//     },
//     selectedBrand: "all", // البراند المختار من الفلتر
//   };

//   componentDidMount() {
//     this.fetchCampaigns();
//   }

//   getAuthHeaders() {
//     return {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${localStorage.getItem("token")}`,
//     };
//   }

//   async fetchCampaigns() {
//     try {
//       const res = await fetch("http://backend.goldensection.agency/public/api/getuser", {
//         headers: this.getAuthHeaders(),
//       });
//       const data = await res.json();

//       const allCampaigns = data.users.flatMap((user) =>
//         (user.whatsapp || []).map((c) => ({
//           ...c,
//           brand: user.brand,
//           user_id: user.id,
//         }))
//       );

//       this.setState({
//         campaigns: allCampaigns,
//         loading: false,
//       });
//     } catch (err) {
//       this.setState({ error: "فشل تحميل الحملات", loading: false });
//     }
//   }

//   handleEdit = (campaign) => {
//     this.setState({
//       showPopup: true,
//       currentCampaign: campaign,
//       formData: {
//         code_name: campaign.code_name,
//         sales: campaign.sales,
//       },
//     });
//   };

//   handleSave = async () => {
//     const { currentCampaign, formData } = this.state;
//     try {
//       await fetch(
//         `http://backend.goldensection.agency/public/api/updatewhatsapp/${currentCampaign.id}`,
//         {
//           method: "POST",
//           headers: this.getAuthHeaders(),
//           body: JSON.stringify(formData),
//         }
//       );
//       this.setState({ showPopup: false });
//       this.fetchCampaigns();
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   handleCancel = () => {
//     this.setState({ showPopup: false, currentCampaign: null });
//   };

//   handleDelete = async (id) => {
//     if (!window.confirm("هل تريد حذف العنصر بالفعل؟")) return;
//     try {
//       await fetch(
//         `http://backend.goldensection.agency/public/api/deletewhatsapp/${id}`,
//         {
//           method: "DELETE",
//           headers: this.getAuthHeaders(),
//         }
//       );
//       this.fetchCampaigns();
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   handleToggleStatus = async (campaign) => {
//     try {
//       const newStatus = campaign.status === "on" ? "off" : "on";
//       await fetch(
//         `http://backend.goldensection.agency/public/api/updatewhatsapp/${campaign.id}`,
//         {
//           method: "POST",
//           headers: this.getAuthHeaders(),
//           body: JSON.stringify({ ...campaign, status: newStatus }),
//         }
//       );
//       this.fetchCampaigns();
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   handleDuplicate = async (campaign) => {
//     try {
//       await fetch("http://backend.goldensection.agency/public/api/addwhatsapp", {
//         method: "POST",
//         headers: this.getAuthHeaders(),
//         body: JSON.stringify({
//           user_id: campaign.user_id,
//           code_name: campaign.code_name + " Copy",
//           sales: campaign.sales,
//           status: campaign.status,
//           period: campaign.period,
//           customer: campaign.customer,
//           created_at: new Date().toISOString(),
//         }),
//       });
//       this.fetchCampaigns();
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   render() {
//     const { campaigns, loading, error, showPopup, formData, selectedBrand } =
//       this.state;

//     // استخراج كل البراندات من الحملات
//     const brands = [...new Set(campaigns.map((c) => c.brand))];

//     // فلترة الحملات حسب البراند
//     const filteredCampaigns =
//       selectedBrand === "all"
//         ? campaigns
//         : campaigns.filter((c) => c.brand === selectedBrand);

//     return (
//       <div className="seo-page">
//         <nav className="seo-navbar">
//           <h1 className="nav-title">حملات الواتس اب</h1>
//           <LogOut />
//           <button className="add1">
//             <Link to="/admin">العودة للرئيسية</Link>
//           </button>
//           <div style={{ margin: "20px 0", textAlign: "right" }}>
//             <label
//               style={{
//                 marginLeft: "10px",
//                 fontWeight: "bold",
//                 fontSize: "16px",
//                 color: "#ffffff",
//               }}
//             >
//               اختر البراند:
//             </label>
//             <select
//               value={selectedBrand}
//               onChange={(e) => this.setState({ selectedBrand: e.target.value })}
//               style={{
//                 padding: "8px 12px",
//                 borderRadius: "8px",
//                 border: "1px solid #ccc",
//                 fontSize: "15px",
//                 background: "#f9f9f9",
//                 color: "#333",
//                 cursor: "pointer",
//                 outline: "none",
//               }}
//             >
//               <option value="all">الكل</option>
//               {brands.map((brand) => (
//                 <option key={brand} value={brand}>
//                   {brand}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </nav>

//         <div className="admin_area">
//           {loading && <p>جار التحميل...</p>}
//           {error && <p>{error}</p>}

//           {/* فلتر اختيار البراند */}

//           <table className="users-table">
//             <thead>
//               <tr>
//                 <th>اسم البراند</th>
//                 <th>تاريخ الحملة</th>
//                 <th>فترة الحملة</th>
//                 <th>اسم الكود</th>
//                 <th>عدد العملاء</th>
//                 <th>المبيعات</th>
//                 {!isGust && <th>الإجراءات</th>}
//               </tr>
//             </thead>
//             <tbody>
//               {filteredCampaigns.map((c) => (
//                 <tr key={c.id}>
//                   <td>{c.brand}</td>
//                   <td>{new Date(c.created_at).toLocaleDateString()}</td>
//                   <td>{c.period}</td>
//                   <td>{c.code_name}</td>
//                   <td>{c.customer}</td>
//                   <td>{c.sales}</td>
//                   {!isGust && (
//                     <td className="editdelet">
//                       <button
//                         className="delete-btn"
//                         onClick={() => this.handleEdit(c)}
//                       >
//                         <img src={editnumber} alt="edit" />
//                       </button>
//                       <button
//                         className="edit-btn"
//                         onClick={() => this.handleToggleStatus(c)}
//                       >
//                         <img
//                           src={c.status === "on" ? openEye : closedEye}
//                           alt="status"
//                         />
//                       </button>
//                       <button
//                         className="edit-btn"
//                         onClick={() => this.handleDuplicate(c)}
//                       >
//                         <img src={duplicate} alt="duplicate" />
//                       </button>
//                       <button
//                         className="edit-btn"
//                         onClick={() => this.handleDelete(c.id)}
//                       >
//                         <img src={trash} alt="trash" />
//                       </button>
//                     </td>
//                   )}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         {showPopup && (
//           <div className="popup-overlay">
//             <div className="popup">
//               <button className="cancel-btn" onClick={this.handleCancel}>
//                 ✕
//               </button>
//               <label> الفترة:</label>
//               <input
//                 type="text"
//                 value={formData.period}
//                 onChange={(e) =>
//                   this.setState({
//                     formData: { ...formData, period: e.target.value },
//                   })
//                 }
//               />
//               <label>اسم الكود:</label>
//               <input
//                 type="text"
//                 value={formData.code_name}
//                 onChange={(e) =>
//                   this.setState({
//                     formData: { ...formData, code_name: e.target.value },
//                   })
//                 }
//               />

//               <label>عدد العملاء:</label>
//               <input
//                 type="number"
//                 value={formData.customer}
//                 onChange={(e) =>
//                   this.setState({
//                     formData: { ...formData, customer: e.target.value },
//                   })
//                 }
//               />

//               <label>المبيعات:</label>
//               <input
//                 type="number"
//                 value={formData.sales}
//                 onChange={(e) =>
//                   this.setState({
//                     formData: { ...formData, sales: e.target.value },
//                   })
//                 }
//               />
//               <div className="popup-actions">
//                 <button className="save-btn" onClick={this.handleSave}>
//                   حفظ
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     );
//   }
// }

// export default Whats;
import React, { Component } from "react";
import { Link } from "react-router-dom";
import LogOut from "../components/LogOut";
import closedEye from "../assets/eye.png";
import openEye from "../assets/openeye.png";
import editnumber from "../assets/pen-number.png";
import duplicate from "../assets/dublicat.png";
import trash from "../assets/trash.png";

const isGust = localStorage.getItem("role") === "gust";

export class Whats extends Component {
  state = {
    campaigns: [],
    loading: true,
    error: null,
    showPopup: false,
    currentCampaign: null,
    formData: {
      code_name: "",
      sales: "",
      period: "",
      customer: "",
    },
    selectedBrand: "all",
    dateFrom: "",
    dateTo: "",
  };

  componentDidMount() {
    this.fetchCampaigns();
  }

  getAuthHeaders() {
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    };
  }

  async fetchCampaigns() {
    try {
      const res = await fetch(
        "http://backend.goldensection.agency/public/api/getuser",
        {
          headers: this.getAuthHeaders(),
        },
      );
      const data = await res.json();

      const allCampaigns = data.users.flatMap((user) =>
        (user.whatsapp || []).map((c) => ({
          ...c,
          brand: user.brand,
          user_id: user.id,
        })),
      );

      this.setState({ campaigns: allCampaigns, loading: false });
    } catch (err) {
      this.setState({ error: "فشل تحميل الحملات", loading: false });
    }
  }

  handleEdit = (campaign) => {
    this.setState({
      showPopup: true,
      currentCampaign: campaign,
      formData: {
        code_name: campaign.code_name,
        sales: campaign.sales,
        period: campaign.period,
        customer: campaign.customer,
      },
    });
  };

  handleSave = async () => {
    const { currentCampaign, formData } = this.state;
    try {
      await fetch(
        `http://backend.goldensection.agency/public/api/updatewhatsapp/${currentCampaign.id}`,
        {
          method: "POST",
          headers: this.getAuthHeaders(),
          body: JSON.stringify(formData),
        },
      );
      this.setState({ showPopup: false });
      this.fetchCampaigns();
    } catch (err) {
      console.error(err);
    }
  };

  handleCancel = () => {
    this.setState({ showPopup: false, currentCampaign: null });
  };

  handleDelete = async (id) => {
    if (!window.confirm("هل تريد حذف العنصر بالفعل؟")) return;
    try {
      await fetch(
        `http://backend.goldensection.agency/public/api/deletewhatsapp/${id}`,
        {
          method: "DELETE",
          headers: this.getAuthHeaders(),
        },
      );
      this.fetchCampaigns();
    } catch (err) {
      console.error(err);
    }
  };

  handleToggleStatus = async (campaign) => {
    try {
      const newStatus = campaign.status === "on" ? "off" : "on";
      await fetch(
        `http://backend.goldensection.agency/public/api/updatewhatsapp/${campaign.id}`,
        {
          method: "POST",
          headers: this.getAuthHeaders(),
          body: JSON.stringify({ ...campaign, status: newStatus }),
        },
      );
      this.fetchCampaigns();
    } catch (err) {
      console.error(err);
    }
  };

  handleDuplicate = async (campaign) => {
    try {
      await fetch(
        "http://backend.goldensection.agency/public/api/addwhatsapp",
        {
          method: "POST",
          headers: this.getAuthHeaders(),
          body: JSON.stringify({
            user_id: campaign.user_id,
            code_name: campaign.code_name + " Copy",
            sales: campaign.sales,
            status: campaign.status,
            period: campaign.period,
            customer: campaign.customer,
            created_at: new Date().toISOString(),
          }),
        },
      );
      this.fetchCampaigns();
    } catch (err) {
      console.error(err);
    }
  };

  resetFilters = () => {
    this.setState({ selectedBrand: "all", dateFrom: "", dateTo: "" });
  };

  render() {
    const {
      campaigns,
      loading,
      error,
      showPopup,
      formData,
      selectedBrand,
      dateFrom,
      dateTo,
    } = this.state;

    const brands = [...new Set(campaigns.map((c) => c.brand))];

    // فلترة حسب البراند + التاريخ
    const filteredCampaigns = campaigns.filter((c) => {
      const matchBrand = selectedBrand === "all" || c.brand === selectedBrand;

      const campaignDate = new Date(c.created_at);
      const from = dateFrom ? new Date(dateFrom) : null;
      const to = dateTo ? new Date(dateTo) : null;

      // نضيف آخر اليوم للـ dateTo عشان يشمل اليوم كله
      if (to) to.setHours(23, 59, 59, 999);

      const matchFrom = from ? campaignDate >= from : true;
      const matchTo = to ? campaignDate <= to : true;

      return matchBrand && matchFrom && matchTo;
    });

    return (
      <div className="seo-page">
        <nav className="seo-navbar">
          <h1 className="nav-title">حملات الواتس اب</h1>
          <LogOut />
          <button className="add1">
            <Link to="/admin">العودة للرئيسية</Link>
          </button>

          {/* ======= شريط الفلاتر ======= */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
              flexWrap: "wrap",
              margin: "12px 0",
            }}
          >
            {/* فلتر البراند */}
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <label
                style={{ fontWeight: "bold", fontSize: "15px", color: "#fff" }}
              >
                البراند:
              </label>
              <select
                value={selectedBrand}
                onChange={(e) =>
                  this.setState({ selectedBrand: e.target.value })
                }
                style={selectStyle}
              >
                <option value="all">الكل</option>
                {brands.map((brand) => (
                  <option key={brand} value={brand}>
                    {brand}
                  </option>
                ))}
              </select>
            </div>

            {/* فلتر من تاريخ */}
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <label
                style={{ fontWeight: "bold", fontSize: "15px", color: "#fff" }}
              >
                من:
              </label>
              <input
                type="date"
                value={dateFrom}
                onChange={(e) => this.setState({ dateFrom: e.target.value })}
                style={selectStyle}
              />
            </div>

            {/* فلتر إلى تاريخ */}
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <label
                style={{ fontWeight: "bold", fontSize: "15px", color: "#fff" }}
              >
                إلى:
              </label>
              <input
                type="date"
                value={dateTo}
                onChange={(e) => this.setState({ dateTo: e.target.value })}
                style={selectStyle}
              />
            </div>

            {/* زر إعادة الضبط */}
            {(selectedBrand !== "all" || dateFrom || dateTo) && (
              <button
                onClick={this.resetFilters}
                style={{
                  padding: "7px 14px",
                  borderRadius: "8px",
                  border: "none",
                  background: "#e74c3c",
                  color: "#fff",
                  fontWeight: "bold",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                مسح الفلاتر
              </button>
            )}
          </div>
          {/* ============================== */}
        </nav>

        <div className="admin_area">
          {loading && <p>جار التحميل...</p>}
          {error && <p>{error}</p>}

          <table className="users-table">
            <thead>
              <tr>
                <th>اسم البراند</th>
                <th>تاريخ الحملة</th>
                <th>فترة الحملة</th>
                <th>اسم الكود</th>
                <th>عدد العملاء</th>
                <th>المبيعات</th>
                {!isGust && <th>الإجراءات</th>}
              </tr>
            </thead>
            <tbody>
              {filteredCampaigns.length === 0 && !loading && (
                <tr>
                  <td colSpan={isGust ? 6 : 7} style={{ textAlign: "center" }}>
                    لا توجد نتائج
                  </td>
                </tr>
              )}
              {filteredCampaigns.map((c) => (
                <tr key={c.id}>
                  <td>{c.brand}</td>
                  <td>{new Date(c.created_at).toLocaleDateString("ar-EG")}</td>
                  <td>{c.period}</td>
                  <td>{c.code_name}</td>
                  <td>{c.customer}</td>
                  <td>{c.sales}</td>
                  {!isGust && (
                    <td className="editdelet">
                      <button
                        className="delete-btn"
                        onClick={() => this.handleEdit(c)}
                      >
                        <img src={editnumber} alt="edit" />
                      </button>
                      <button
                        className="edit-btn"
                        onClick={() => this.handleToggleStatus(c)}
                      >
                        <img
                          src={c.status === "on" ? openEye : closedEye}
                          alt="status"
                        />
                      </button>
                      <button
                        className="edit-btn"
                        onClick={() => this.handleDuplicate(c)}
                      >
                        <img src={duplicate} alt="duplicate" />
                      </button>
                      <button
                        className="edit-btn"
                        onClick={() => this.handleDelete(c.id)}
                      >
                        <img src={trash} alt="trash" />
                      </button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {showPopup && (
          <div className="popup-overlay">
            <div className="popup">
              <button className="cancel-btn" onClick={this.handleCancel}>
                ✕
              </button>
              <label>الفترة:</label>
              <input
                type="text"
                value={formData.period}
                onChange={(e) =>
                  this.setState({
                    formData: { ...formData, period: e.target.value },
                  })
                }
              />
              <label>اسم الكود:</label>
              <input
                type="text"
                value={formData.code_name}
                onChange={(e) =>
                  this.setState({
                    formData: { ...formData, code_name: e.target.value },
                  })
                }
              />
              <label>عدد العملاء:</label>
              <input
                type="number"
                value={formData.customer}
                onChange={(e) =>
                  this.setState({
                    formData: { ...formData, customer: e.target.value },
                  })
                }
              />
              <label>المبيعات:</label>
              <input
                type="number"
                value={formData.sales}
                onChange={(e) =>
                  this.setState({
                    formData: { ...formData, sales: e.target.value },
                  })
                }
              />
              <div className="popup-actions">
                <button className="save-btn" onClick={this.handleSave}>
                  حفظ
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

// ستايل مشترك للـ select والـ date inputs
const selectStyle = {
  padding: "7px 12px",
  borderRadius: "8px",
  border: "1px solid #ccc",
  fontSize: "14px",
  background: "#f9f9f9",
  color: "#333",
  cursor: "pointer",
  outline: "none",
};

export default Whats;
